module.exports = __webpack_public_path__ + "img/avatar-2.452107b1.png";